var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-group",
    [
      _c("b-form-input", {
        attrs: {
          type: "number",
          "aria-describedby": "input-live-feedback",
          min: _vm.schema.min,
          max: _vm.schema.max,
          state: _vm.validaNumero,
        },
        on: { change: _vm.validaNumero2 },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      }),
      _c("b-form-invalid-feedback", { attrs: { id: "input-live-feedback" } }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.$t("valorminimo") +
                ": " +
                (_vm.schema.min || "-") +
                " - " +
                _vm.$t("valormaximo") +
                ": " +
                (_vm.schema.max || "-")
            ) +
            " "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }